<div class="card" id="card">
  <div class="card-header">
    <nav class="navbar navbar-light bg-light navbar-expand-lg">
      <form [formGroup]="form" class="form-inline flex-fill" id="formularioFiltros" >
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <ul class="navbar-nav me-auto">

          @if (modificaciones?.length > 0 || modificacionesBloqueos?.length > 0){
            <li class="nav-item me-2" >
              <div class="nav-item">
                <input
                  id="busquedaFormControl"
                  type="text"
                  class="form-control"
                  placeholder="Raz&oacute;n social/Cuit"
                  formControlName="buscadorFormControl"
                />
              </div>
            </li>

            <!--ESTADOS-->
            <li class="nav-item me-2">
              <div ngbDropdown>
                <button class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" id="dropdownForm1" ngbDropdownToggle>
                  Estados
                </button>

                <div ngbDropdownMenu aria-labelledby="dropdownForm1">
                  <div class="px-4 py-3" formArrayName="estadosFormControl">
                    <div *ngFor="let estado of enumEstados; let i = index">
                      <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [id]="'dropdownCheck' + estado"
                               [formControlName]="i" />
                        <label class="form-check-label text-nowrap"
                               [for]="'dropdownCheck' + estado">
                          {{ obtenerEtiqueta(estado) }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </li>
          }
          <!-- desde -->
          <li class="nav-item me-2">
            <div class="input-group">
              <!-- fecha desde -->
              <input
                type="date"
                class="form-control"
                placeholder="aaaa-mm-dd"
                formControlName="fechaDesdeFormControl"
                [maxDate]="calendar.getToday()"
                ngbDatepicker
                #dExcedidoDesde="ngbDatepicker"
                ngbTooltip="Seleccione una fecha."
                readonly/>
              <div class="input-group-append">
                <button class="btn btn-secondary" (click)="dExcedidoDesde.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </div>
            </div>
          </li>
          <!-- fecha hasta -->
          <li class="nav-item">
            <div class="input-group">
              <input
                type="date"
                class="form-control"
                placeholder="aaaa-mm-dd"
                formControlName="fechaHastaFormControl"
                ngbDatepicker
                #dExcedidoHasta="ngbDatepicker"
                ngbTooltip="Seleccione una fecha."
                readonly/>
              <div class="input-group-append">
                <button class="btn btn-secondary" (click)="dExcedidoHasta.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <button [disabled]="form.get('fechaHastaFormControl')?.hasError('rangoInvalido') ||
                                form.get('fechaHastaFormControl')?.hasError('diferenciaMaximaExcedida') ||
                                obteniendoInformacion"
                    class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" (click)="buscarDesdeHasta()" type="submit">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </li>
        </ul>
      </form>
      <div class="mt-2 float-end">
        <button type="button" [disabled]="obteniendoInformacion || (todasLasModificaciones?.modificacionesSaldo?.length == 0 && todasLasModificaciones?.modificacionesConfiguracionBloqueo?.length == 0)"
                styleSheetFile="assets/css/print.css,assets/css/bootstrap.min.css"
                (click)="print()" class="btn btn-outline-secondary" ngxPrint>
          <i class="fa fa-print" aria-hidden="true"></i> Imprimir</button>
      </div>
    </nav>
    <div class="row">
      <div class="col-md-12">
        @if (form.get('fechaHastaFormControl')?.hasError('rangoInvalido')) {
          <ngb-alert type="warning" [dismissible]="false" class="alert alert-danger">
            Fecha desde no puede ser mayor a fecha hasta
          </ngb-alert>
        } @else if (form.get('fechaHastaFormControl')?.hasError('diferenciaMaximaExcedida')){
          <ngb-alert type="warning" [dismissible]="false" class="alert alert-danger">
            La diferencia entre la fecha desde y hasta no puede ser mayor a 31 d&iacute;as
          </ngb-alert>
        }
      </div>
    </div>
  </div>
  <div class="card-body scroll-container" id="contenedorPrint">
    <div class="row">
      <div class="col-md-12">
        @if (todasLasModificaciones?.modificacionesConfiguracionBloqueo.length == 0 && todasLasModificaciones?.modificacionesSaldo?.length == 0 && !obteniendoInformacion){
          <div class="alert alert-warning">
            No hay registros para el criterio seleccionado.
          </div>
        }
        @if (obteniendoInformacion) {
          <div class="spinner-container">
            <ngx-spinner name="spinnerReporteAutorizaciones" bdOpacity=0.3bd
                         Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
              <p style="color: white">Obteniendo datos ...</p>
            </ngx-spinner>
          </div>
        }
        <div class="card-header print col-md-12 subtitulo">
            Listado de modificaciones entre {{formatDate(this.form.get('fechaDesdeFormControl').value, false, true) }} y {{formatDate(this.form.get('fechaHastaFormControl').value, true, true)}}
            (Estados {{obtenerEtiquetas(estadosArray.value)}}).
        </div>
        <div *ngIf="!obteniendoInformacion && (todasLasModificaciones?.modificacionesSaldo?.length > 0 || todasLasModificaciones?.modificacionesConfiguracionBloqueo?.length > 0)">
          @for (item of combinedFilteredSorted; track item.data.id) {
            @if (item.type === 'saldo') {
              <!-- HTML para modificacionesSaldo -->
              <div class="contenedorModificacion">
                <div class="no-break">
                  <div class="col-md-10 offset-md-1">
                    <div class="row">
                      <div class="titulo col-md-9" style="margin-top: 1em;">
                        CREACIÓN DE SOLICITUD CREDITICIA - Estado: {{ utilCredito.obtenerDescripcionEstadoModificacion(item.data.estado) }}.
                      </div>
                      <div class="col-md-3" style="margin-top: 1em;">
                        <button type="button" (click)="mostrarOcultarModificacionesCredito(item.data.id)" class="btn btn-primary btn-sm no-print">
                          {{ mostrarModificacionesCredito(item.data.id) ? "Ocultar" : "Ver" }} modificaciones
                        </button>
                      </div>
                    </div>
                  <div class="subtitulo">
                      <span>{{item.data.clienteRazonSocial}} ({{item.data.clienteCuit}})</span>
                  </div>
                  <div style="margin-bottom: 1em;"  class="detalle">
                      <span style="">Creaci&oacute;n: {{item.data.fechaSolicitud  | date: "d'/'MM'/'y' 'hh:mm a"}} por {{item.data.usuarioResponsable?.nombresCompletos}}</span>
                      <span style="margin-bottom: 1em;" *ngIf="item.data.estado == enumEstadoSolicitudCliente.Aprobado || item.data.estado == enumEstadoSolicitudCliente.Rechazado">
                        &nbsp; | &nbsp;
                        <span *ngIf="item.data.estado == enumEstadoSolicitudCliente.Aprobado">Aprobado: {{item.data.fechaModificacion | date: "d'/'MM'/'y' 'hh:mm a"}} por {{item.data.usuarioResponsable?.nombresCompletos}}.</span>
                        <span *ngIf="item.data.estado == enumEstadoSolicitudCliente.Rechazado">Rechazado: {{item.data.fechaModificacion | date: "d'/'MM'/'y' 'hh:mm a"}} por {{item.data.usuarioResponsable?.nombresCompletos}}.</span>
                      </span>

                  </div>
                  <div  class="col-md-12 motivo-modificacion" style="margin-top:0.75em">
                    <b>Motivos de modificaci&oacute;n:</b>
                    <br/>
                    <div class="detalle-motivo-modificacion">
                      {{ item.data.motivo ?? '' }}
                    </div>
                  </div>
                  <div class="row col-md-11 offset-md-1 cliente" *ngIf="mostrarModificacionesCredito(item.data.id)">
                    <div class="row contenedor-modificacion">
                      <table id="modificacion-cliente" class="table reducida">
                        <tr>
                          <th class="">Datos Nuevos</th>
                        </tr>
                          <tr *ngFor="let item of obtenerModificacionesCredito(item.data.saldoViejoDTO, item.data.saldoNuevoDTO)">
                            <td [innerHTML]="item.solicitudNuevaDTO"></td>
                          </tr>

                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="contenedorModificacion">
              <div class="no-break">
                <div class="col-md-10 offset-md-1">
                  <div class="row">
                    <div class="titulo col-md-9" style="margin-top: 1em;">
                      NUEVA SOLICITUD DE CONFIGURACI&Oacute;N DE BLOQUEO {{item.data.situacionExcedido?.estadoModificacion !== null ? '- Estado Excedido: ' : ''}} {{this.utilCredito.obtenerDescripcionEstadoModificacion(item.data.situacionExcedido?.estadoModificacion)}} {{item.data.situacionVencido?.estadoModificacion !== null ? '- Estado Vencido: ' : ''}} {{this.utilCredito.obtenerDescripcionEstadoModificacion(item.data.situacionVencido?.estadoModificacion)}}.
                    </div>
                    <div class="col-md-3" style="margin-top: 1em;">
                      <button type="button" (click)="mostrarOcultarModificacionesCredito(item.data.id)" class="btn btn-primary btn-sm no-print">
                        {{ mostrarModificacionesCredito(item.data.id) ? "Ocultar" : "Ver" }} modificaciones
                      </button>
                    </div>
                  </div>
                  <div class="subtitulo">
                    <span>{{item.data.razonSocial}} ({{item.data.clienteCuit}})</span>
                  </div>
                  <div style="margin-bottom: 1em;"  class="detalle">
                    <span style="">Creaci&oacute;n: {{item.data.fecha  | date: "d'/'MM'/'y' 'hh:mm a"}} por {{item.data.usuarioSolicitante?.nombresCompletos}}</span><br>
                    <span style="margin-bottom: 1em;" *ngIf="item.data.situacionExcedido?.estadoModificacion === enumEstadoSolicitudCliente.Aprobado || item.data.situacionExcedido?.estadoModificacion == enumEstadoSolicitudCliente.Rechazado">
                        <span *ngIf="item.data.situacionExcedido?.estadoModificacion == enumEstadoSolicitudCliente.Aprobado">Excedido Aprobado: {{item.data.situacionExcedido?.fechaActualizacion | date: "d'/'MM'/'y' 'hh:mm a"}} por {{item.data.situacionExcedido?.usuarioResponsable?.nombresCompletos}}.</span>
                        <span *ngIf="item.data.situacionExcedido?.estadoModificacion == enumEstadoSolicitudCliente.Rechazado">Excedido Rechazado: {{item.data.situacionExcedido?.fechaActualizacion | date: "d'/'MM'/'y' 'hh:mm a"}} por {{item.data.situacionExcedido?.usuarioResponsable?.nombresCompletos}}.</span>
                        <br>
                    </span>
                    <span style="margin-bottom: 1em;" *ngIf="item.data.situacionVencido?.estadoModificacion === enumEstadoSolicitudCliente.Aprobado || item.data.situacionVencido?.estadoModificacion == enumEstadoSolicitudCliente.Rechazado">
                        <span *ngIf="item.data.situacionVencido?.estadoModificacion == enumEstadoSolicitudCliente.Aprobado">Vencido Aprobado: {{item.data.situacionVencido?.fechaActualizacion | date: "d'/'MM'/'y' 'hh:mm a"}} por {{item.data.situacionVencido?.usuarioResponsable?.nombresCompletos}}.</span>
                        <span *ngIf="item.data.situacionVencido?.estadoModificacion == enumEstadoSolicitudCliente.Rechazado">Vencido Rechazado: {{item.data.situacionVencido?.fechaActualizacion | date: "d'/'MM'/'y' 'hh:mm a"}} por {{item.data.situacionVencido?.usuarioResponsable?.nombresCompletos}}.</span>
                        <br>
                    </span>
                  </div>
                  <div class="row col-md-11 offset-md-1 cliente" *ngIf="mostrarModificacionesCredito(item.data.id)">
                    <div class="row contenedor-modificacion">
                      <table id="modificacion-cliente" class="table reducida">
                        <tr>
                          <th class="">Datos viejos</th>
                          <th class="">Datos Nuevos</th>
                        </tr>
                        <tr *ngIf="item.data.situacionExcedido?.estadoModificacion !== null">
                          <td>Excedido: {{this.obtenerEtiquetaBloqueos(item.data.situacionExcedido?.situacionAnterior)}}</td>
                          <td>Excedido: {{this.obtenerEtiquetaBloqueos(item.data.situacionExcedido?.situacionActual)}}</td>
                        </tr>
                        <tr *ngIf="item.data.situacionVencido?.estadoModificacion !== null">
                          <td>Vencido: {{this.obtenerEtiquetaBloqueos(item.data.situacionVencido?.situacionAnterior)}}</td>
                          <td>Vencido: {{this.obtenerEtiquetaBloqueos(item.data.situacionVencido?.situacionActual)}}</td>
                        </tr>

                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              }
          }
        </div>
      </div>
    </div>
  </div>
</div>
